import { createContext } from 'react'

type ContextValue = {
  dayViewNumberOfDays: number
  setDayViewNumberOfDays: (number: number) => void
}

const defaultValue: ContextValue = {
  dayViewNumberOfDays: 1,
  setDayViewNumberOfDays: () => {
    console.warn('setDayViewNumberOfDays - no function provided')
  },
}

const MultiViewCalendarContext = createContext(defaultValue)

export default MultiViewCalendarContext
